import type { AutoGenerateConfig, LabelObject } from '@/types/labelTemplate';

export const DEFAULT_AUTO_GENERATE_CONFIG: AutoGenerateConfig = {
  prefix: '',
  suffix: '',
  startValue: 1,
  increment: 1,
  padding: 6,
};

export function formatSequenceValue(cfg: AutoGenerateConfig, value: number): string {
  return `${cfg.prefix || ''}${String(Math.max(0, Math.trunc(value))).padStart(cfg.padding || 0, '0')}${cfg.suffix || ''}`;
}

/** The `count` values a batch of `count` physical labels should each carry, in print order. */
export function expandSequenceRange(cfg: AutoGenerateConfig, rangeStart: number, count: number): string[] {
  return Array.from({ length: count }, (_, i) => formatSequenceValue(cfg, rangeStart + i * (cfg.increment || 1)));
}

/**
 * Stamps onto a label object the concrete value the one physical label it belongs to will carry,
 * and CLEARS autoGenerate.
 *
 * Clearing is the whole point. LabelObjectRenderer treats a set autoGenerate as "this is still a
 * design-time placeholder" and renders formatSequenceValue(cfg, cfg.startValue) — the same seed
 * value every time — in preference to the object's own data/text. Leaving the config in place while
 * substituting the real value therefore had no visible effect: every printed label rendered the
 * start value (R000001) no matter which value had actually been reserved and recorded for it.
 */
export function applySequenceValue(object: LabelObject, value: string): LabelObject {
  return {
    ...object,
    autoGenerate: undefined,
    ...(object.type === 'text' ? { text: value } : { data: value }),
  } as LabelObject;
}
